/** Parse "15.0 EUR", "€15", "15€", "INR 500" into amount + ISO currency. */

const SYMBOL_TO_CODE = {
  "€": "EUR",
  "£": "GBP",
  "₹": "INR",
  $: "USD",
};

function normalizeCurrencyToken(token) {
  const raw = String(token || "").trim();
  if (!raw) return "";
  if (SYMBOL_TO_CODE[raw]) return SYMBOL_TO_CODE[raw];
  const code = raw.toUpperCase().replace(/[^A-Z]/g, "").slice(0, 12);
  return code;
}

function parseAmountToken(token) {
  const normalized = String(token || "").trim().replace(",", ".");
  if (!normalized) return NaN;
  return Number(normalized);
}

/**
 * @param {unknown} raw
 * @returns {{ ok: true, amount: number, currency: string } | { ok: false, error: string }}
 */
export function parseAmountWithCurrency(raw) {
  const s = String(raw || "").trim();
  if (!s) {
    return { ok: false, error: "Enter a price with amount and currency (e.g. 15.0 EUR)." };
  }

  const amountThenCurrency = s.match(/^(\d+(?:[.,]\d+)?)\s*([A-Za-z€£₹$]{1,12})$/u);
  if (amountThenCurrency) {
    const amount = parseAmountToken(amountThenCurrency[1]);
    const currency = normalizeCurrencyToken(amountThenCurrency[2]);
    if (!Number.isFinite(amount) || amount < 0) {
      return { ok: false, error: "Enter a valid amount (e.g. 15.0 EUR)." };
    }
    if (!currency) {
      return { ok: false, error: "Add a currency (e.g. 15.0 EUR)." };
    }
    return { ok: true, amount, currency };
  }

  const currencyThenAmount = s.match(/^([A-Za-z€£₹$]{1,12})\s*(\d+(?:[.,]\d+)?)$/u);
  if (currencyThenAmount) {
    const currency = normalizeCurrencyToken(currencyThenAmount[1]);
    const amount = parseAmountToken(currencyThenAmount[2]);
    if (!currency) {
      return { ok: false, error: "Add a currency (e.g. 15.0 EUR)." };
    }
    if (!Number.isFinite(amount) || amount < 0) {
      return { ok: false, error: "Enter a valid amount (e.g. 15.0 EUR)." };
    }
    return { ok: true, amount, currency };
  }

  // Amount only — currency missing
  if (/^\d+(?:[.,]\d+)?$/.test(s)) {
    return { ok: false, error: "Add a currency (e.g. 15.0 EUR)." };
  }

  return { ok: false, error: "Enter a price like 15.0 EUR." };
}

/** Prefill / display string for an amount + school currency. */
export function formatAmountWithCurrency(amount, currency) {
  if (amount == null || amount === "") return "";
  const n = Number(amount);
  if (!Number.isFinite(n)) return "";
  const code = String(currency || "").trim().toUpperCase();
  const amountText = Number.isInteger(n) ? String(n) : String(n);
  return code ? `${amountText} ${code}` : amountText;
}
